import {
    ExplanationModalType,
    RouteInfoAction
} from "../../Reducers/Client/RouteInfoReducer"
import { RouteInfoType } from "../Types"

export const setExplanationModal = (
    visible: boolean,
    type: ExplanationModalType
): RouteInfoAction => ({
    type: RouteInfoType.showTimeoutExplanationModal,
    payload: {
        visible,
        type
    }
})
